import { render, staticRenderFns } from "./WorkSubProject.vue?vue&type=template&id=c4aa5a76"
import script from "./WorkSubProject.vue?vue&type=script&lang=js"
export * from "./WorkSubProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports